
import { Vue, Component } from "vue-property-decorator";
import ContentHeader from "@/components/UIComponents/ContentHeader.vue";
import AppFooter from "@/components/UIComponents/AppFooter.vue";
import { MarketStore, MMCMembersStaffStore } from "@/store/modules";
import type { MMCMembersStaff } from "@/store/model/mmc_staff";
import { removeFilesForPatch, getNestedFormData } from "@/utils/help.utils";

@Component({
  components: { ContentHeader, AppFooter },
})
export default class MmcMemberForm extends Vue {
  headerBackgroundUrl = "about.jpg";

  editId = 0;
  pageHeading = "";
  buttonLabel = "";

  imageData: any = null;
  previewImage: any = "";

  imageInput(event: any) {
    if (event && event.target) {
      this.imageData = event.target.files[0];
      const reader = new FileReader();
      if (this.imageData) {
        reader.readAsDataURL(this.imageData);
      }
      reader.onload = (e: any) => {
        this.previewImage = e.target.result;
      };
    }
  }

  async created() {
    if (this.$route.params.id) {
      this.editId = Number(this.$route.params.id);
      await MMCMembersStaffStore.getMMCMemberStaffById(this.editId);
      if (this.mmcStaffDataByIdData.image) {
        this.previewImage = this.mmcStaffDataByIdData.image;
      }
    } else {
      this.mmcStaffDataByIdData = {
        id: 0,
        market: "",
        name: "",
        designation: "",
        phone_number: "",
        image: "",
      } as MMCMembersStaff;
    }
  }

  get mmcStaffDataByIdData() {
    return MMCMembersStaffStore.SingleMMCMemberStaff;
  }

  set mmcStaffDataByIdData(value: MMCMembersStaff) {
    MMCMembersStaffStore.setMmcMemberStaff(value);
  }

  setHeading() {
    this.editId === 0
      ? (this.pageHeading = "Add")
      : (this.pageHeading = "Edit");
    return this.pageHeading;
  }

  setButtonLabel() {
    this.editId === 0
      ? (this.buttonLabel = "Save")
      : (this.buttonLabel = "Edit");
    return this.buttonLabel;
  }

  async onSubmit() {
    if (this.imageData) {
      this.mmcStaffDataByIdData.image = this.imageData;
    }
    if (this.pageHeading === "Add") {
      await this.createMmcStaff();
      this.$router.push({
        name: "MmcMemberStaffList",
      });
    } else {
      await this.editMmcStaff(this.editId);
      this.$router.push({
        name: "MmcMemberStaffList",
      });
    }
  }

  async editMmcStaff(id: number) {
    removeFilesForPatch([
      {
        property: this.mmcStaffDataByIdData,
        fieldName: "image",
      },
    ]);
    const editFormData = new FormData();
    const editData = getNestedFormData(editFormData, this.mmcStaffDataByIdData);
    await MMCMembersStaffStore.editMMCMemberStaff({ data: editData, id: id })
      .then(() => {
        this.$q.notify({
          message: "Sucessfully Edited",
          color: "info",
        });
      })
      .catch(() => {
        this.$q.notify({
          message: "Error occured while performing this action",
          color: "negative",
        });
      });
  }

  async createMmcStaff() {
    const editFormData = new FormData();
    const editData = getNestedFormData(editFormData, this.mmcStaffDataByIdData);
    await MMCMembersStaffStore.createMMCMemberStaff({ data: editData })
      .then(() => {
        this.$q.notify({
          message: "Sucessfully Created",
          color: "info",
        });
      })
      .catch(() => {
        this.$q.notify({
          message: "Error occured while performing this action",
          color: "negative",
        });
      });
  }

  get marketList() {
    let markets = MarketStore.MarketList.map((x) => {
      return {
        label: x.name_en,
        value: x.id,
      };
    });
    return markets;
  }

  validatesPhoneNumber(phone_number: string) {
    return /(?:\(?\+977\)?)?[9][6-9]\d{8}|01[-]?[0-9]{7}/.test(phone_number);
  }

  async beforeMount() {
    this.mmcStaffDataByIdData.market = MarketStore.MARKETPLACE_ID;

    await MarketStore.getMarketsList();
  }
}
